import { render, staticRenderFns } from "./EventsLandingPage.vue?vue&type=template&id=924582ca&scoped=true&"
import script from "./EventsLandingPage.vue?vue&type=script&lang=js&"
export * from "./EventsLandingPage.vue?vue&type=script&lang=js&"
import style0 from "./EventsLandingPage.vue?vue&type=style&index=0&id=924582ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924582ca",
  null
  
)

export default component.exports